module.exports = __webpack_public_path__ + "static/media/pricing.fa2a9e47.svg";